import Skeleton from 'react-loading-skeleton';

export function RuleActionsSkeleton() {
  return <Skeleton width={50} height={16} />;
}
